module.exports = __webpack_public_path__ + "img/email_not_updated_dark.d156e727.svg";